import ar from "./locales/ar.json";
import cs from "./locales/cs.json";
import da from "./locales/da.json";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import hu from "./locales/hu.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import sk from "./locales/sk.json";
import sv from "./locales/sv.json";
import tr from "./locales/tr.json";

const langs = [
    { code: "de", file: "de.json", iso: "de-DE" },
    { code: "en", file: "en.json", iso: "en-US" },
    { code: "fr", file: "fr.json", iso: "fr-FR" },
    { code: "nl", file: "nl.json", iso: "nl-NL" },
    { code: "ar", file: "ar.json", iso: "ar-AR" },
    { code: "es", file: "es.json", iso: "es-ES" },
    { code: "it", file: "it.json", iso: "it-IT" },
    { code: "ja", file: "ja.json", iso: "ja-JA" },
    { code: "ko", file: "ko.json", iso: "ko-KO" },
    { code: "pl", file: "pl.json", iso: "pl-PL" },
    { code: "sv", file: "sv.json", iso: "sv-SV" },
    { code: "tr", file: "tr.json", iso: "tr-TR" },
    { code: "cs", file: "cs.json", iso: "cs-CZ" },
    { code: "da", file: "da.json", iso: "da-DK" },
    { code: "sk", file: "sk.json", iso: "sk-SK" },
    { code: "hu", file: "hu.json", iso: "hu-HU" },
];

export default defineI18nConfig(() => ({
    availableLocales: langs,
    fallbackLocale: "de",
    globalInjection: true,
    legacy: false,
    locale: "de",
    locales: langs,
    messages: {
        ar,
        cs,
        da,
        de,
        en,
        es,
        fr,
        hu,
        it,
        ja,
        ko,
        nl,
        pl,
        sk,
        sv,
        tr,
    },
    mode: "composition",
    parsePages: false,
    precompile: {
        strictMessage: false,
    },
    strictMessage: false,
    types: "composition",
    vueI18nLoader: false,
}));
